import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { PROFILE } from "../lib/data";

export const UrgentBail = () => (
  <section className="bg-[#C8A24B] text-[#0A0A0A]" data-testid="urgent-bail-strip">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 lg:py-12 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
      <div className="flex items-center gap-5">
        <span className="relative flex h-3 w-3 shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0A0A0A]/50" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-[#0A0A0A]" />
        </span>
        <div>
          <p className="font-mono text-[0.7rem] uppercase tracking-[0.25em] text-[#0A0A0A]/70">Arrest or FIR? Every hour counts</p>
          <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-none mt-2">
            Urgent Bail? <span className="italic">Call now.</span>
          </h3>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <motion.a
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          href={`tel:${PROFILE.phoneTel}`}
          data-testid="urgent-call-button"
          className="inline-flex items-center gap-2 rounded-sm bg-[#0A0A0A] text-[#F7F5F2] px-7 py-4 text-sm font-medium hover:bg-[#111] transition-colors duration-300"
        >
          <Phone size={17} strokeWidth={1.9} /> {PROFILE.phoneDisplay}
        </motion.a>
        <motion.a
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          href={PROFILE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="urgent-whatsapp-button"
          className="inline-flex items-center gap-2 rounded-sm border border-[#0A0A0A]/40 text-[#0A0A0A] px-7 py-4 text-sm font-medium hover:bg-[#0A0A0A] hover:text-[#F7F5F2] transition-colors duration-300"
        >
          <MessageCircle size={17} strokeWidth={1.9} /> WhatsApp Now
        </motion.a>
      </div>
    </div>
  </section>
);
